import { get } from 'lodash'
import React from 'react'
import { Button, Card } from 'react-bootstrap'
import DimensionsPills from '../../dimensions/pill-list'
import AbsolutePosition from '../../common/absolute-position'
import TypeLabel from '../../learning-resource/type-label'
import useClientLocation from '../../../hooks/use-client-location'
import ViewButton from './view-button'

const LearningResourcesCard = ({
    resource = {}
}) => {
    const { windowLocation } = useClientLocation()
    return (
        <Card
            style={{
                boxShadow: '0px 0px 20px 10px rgb(238, 247, 255)',
            }}
        >
            <Card.Body>
                <Card.Title>
                    {resource.name}
                </Card.Title>
                <Card.Subtitle className="mb-2 text-muted">
                    <DimensionsPills dimensions={get(resource, 'dimensions', [])} />
                </Card.Subtitle>
                <Card.Text style={{ color: 'black', padding: '10px' }}>
                    {resource.description}
                </Card.Text>
                <ViewButton resource={resource} />
            </Card.Body>
        </Card>
    )
}

export default LearningResourcesCard